export const OTHER_ID = 'Other';

export const getOtherValue = (value: string[], addOtherLabel?: string) => {
  const addedSymbolsLength = 2; // we add ': ' to other value
  const otherLabelLength = addOtherLabel
    ? addOtherLabel.length + addedSymbolsLength
    : 0;

  const otherItem =
    value.find((item) => item.startsWith(`${addOtherLabel}: `)) || '';
  return otherItem.slice(otherLabelLength);
};
